




















































import {
	defineComponent,
	PropType,
	computed,
	toRefs,
	ref,
} from '@vue/composition-api';
import { Size } from '@front-app/components/constants';
import { Group } from '@front-app/services/GroupsApi/GroupModel';
import { STATUS } from '@front-app/constants/state';
import TrCheckbox from '@front-app/components/inputs/Checkbox.vue';
import { hasAdminPrivileges } from '@front-app/util/permission';
import { CurrentUserStore } from '@front-app/store/singletons/User';
import { useGroupRole } from '@front-app/hooks/useMembershipRole';
import { GroupsLogoStore } from '@front-app/store/singletons/Groups';
import { Routes } from '@front-app/constants/routes';
import { useOnEveryEntry } from '@front-app/hooks/useOnEntry';
import RoleBadge from './RoleBadge.vue';

export default defineComponent({
	components: {
		TrCheckbox,
		RoleBadge,
	},
	props: {
		isChecked: {
			type: Boolean,
			required: true,
		},
		group: {
			type: Object as PropType<Group>,
			required: true,
		},
		size: {
			type: String as PropType<Size>,
			default: Size.LARGE,
		},
		isButton: Boolean,
	},
	setup(props) {
		const logo = computed(() => GroupsLogoStore.get(props.group.id));
		const logoWrapper = ref(null);
		useOnEveryEntry(logoWrapper, () => {
			GroupsLogoStore.fetch(props.group.id);
		});
		const isAdministeredGroup = computed(
			() => hasAdminPrivileges(props.group.role, CurrentUserStore.isCsr.value),
		);
		const toGroup = (groupId: string) => ({ name: Routes.GROUP_MAIN, params: { groupId } });
		return {
			groupRole: useGroupRole(toRefs(props).group),
			isAdministeredGroup,
			logo,
			logoWrapper,
			toGroup,
			isLoading: computed(() => logo.value.status === STATUS.LOADING),
			Size,
		};
	},
});
